/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ViewTaskAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import ViewTaskModal from './ViewTaskModal/index'



/** @type {import('Simple/types.js').View} */
export default function ViewTaskAction({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/ViewTaskAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 cursor="pointer"
 paddingLeft={0}
 paddingRight={0}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ViewTaskModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ViewTaskModal/Content'))}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeMm}
 weight="medium"
 text="View Task"
/>
)}
</TysiaButton>
<ViewTaskModal
  viewPath={`${viewPath}/ViewTaskModal`}
/>
{children}
</React.Fragment>)
}